import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { getLegal } from "@/lib/legalContent";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";

function Layout({ title, sections, updated }) {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white grain">
      <nav className="border-b border-white/5">
        <div className="max-w-3xl mx-auto px-5 h-16 flex items-center justify-between gap-3">
          <Link to="/" className="font-display text-xl font-extrabold" data-testid="legal-home-link">
            Gaim<span className="text-[#007BFF]">Time</span>
          </Link>
          <div className="flex items-center gap-3">
            <LanguageSwitcher compact />
            <Link to="/" className="text-sm text-white/60 hover:text-white transition-colors flex items-center gap-1.5">
              <ArrowLeft size={18} />
            </Link>
          </div>
        </div>
      </nav>
      <main className="max-w-3xl mx-auto px-5 py-12">
        <h1 className="font-display text-3xl md:text-4xl font-extrabold mb-8" data-testid="legal-title">{title}</h1>
        <div className="space-y-6 text-white/70 leading-relaxed text-sm md:text-base">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-display text-lg md:text-xl font-bold text-white mb-2">{s.t}</h2>
              <p>{s.b}</p>
            </section>
          ))}
        </div>
        <p className="mt-12 text-xs text-white/30">{updated}</p>
      </main>
    </div>
  );
}

export function CGV() {
  const { lang } = useI18n();
  const c = getLegal(lang);
  return <Layout title={c.cgv_title} sections={c.cgv} updated={c.updated} />;
}

export function Legal() {
  const { lang } = useI18n();
  const c = getLegal(lang);
  return <Layout title={c.legal_title} sections={c.legal} updated={c.updated} />;
}
